export enum StreamingPlatforms {
  YOUTUBE = 'YOUTUBE',
  TWITCH_VIDEO = 'TWITCH_VIDEO',
  TWITCH_CHANNEL = 'TWITCH_CHANNEL',
}
